import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";

import { Grid, Typography, FormControl, Select, MenuItem } from "@mui/material";

import ButtonBlue from "../../../../shared/general/ButtonBlue";

import DrawerCustom from "../../../../shared/general/Drawer";

import { updateUser } from "../../../../../../actions/user";
import { getEmployeeProfile } from "../../../../../../actions/employee";

//Translator TH-EN
import { useTranslation } from "react-i18next";
import TextFieldTheme from "../../../../shared/general/TextFieldTheme";

const StyledRoot = styled("div")({
  width: 450,
  padding: 24,
  "& .field-label": {
    paddingBottom: 4,
  },
});

const StyledContentLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: 16,
});

const StyledFooter = styled("div")({
  padding: 16,
  display: "flex",
  justifyContent: "flex-end",
  "& .cancel": {
    marginRight: 8,
  },
});

const StyledFormControl = styled(FormControl)({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    "& .MuiOutlinedInput-input": {
      padding: "13.5px 14px",
    },
    "& .MuiInputBase-inputMultiline": {
      padding: 0,
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 360,
    },
  },
};

const Payroll = (props) => {
  const { formData, handleChange } = props;
  const { t, i18n } = useTranslation();

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          {`${t("SalaryCalculate")} ?`}
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isNonPayroll"
            value={formData.isNonPayroll}
            onChange={handleChange}
            MenuProps={MenuProps}
          >
            <MenuItem value={0}>{t("Yes")} </MenuItem>
            <MenuItem value={1}>{t("No")}</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          {`${t("IncomeTaxCalculate")} ?`}
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isTax"
            value={formData.isTax}
            onChange={handleChange}
          >
            <MenuItem value={1}>{t("Yes")}</MenuItem>
            <MenuItem value={0}>{t("No")}</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          {`${t("SocialSecurityCalculate")} ?`}
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isSso"
            value={formData.isSso}
            onChange={handleChange}
          >
            <MenuItem value={1}>{t("Yes")}</MenuItem>
            <MenuItem value={0}>{t("No")}</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          {`${t("ProvidentFundCalculate")} ?`}
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isPf"
            value={formData.isPf}
            onChange={handleChange}
          >
            <MenuItem value={1}>{t("Yes")}</MenuItem>
            <MenuItem value={0}>{t("No")}</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          {`${t("EmployeeWelfareFundCalculate")} ?`}
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isEWF"
            value={formData.isEWF}
            onChange={handleChange}
          >
            <MenuItem value={1}>{t("Yes")}</MenuItem>
            <MenuItem value={0}>{t("No")}</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          {`${t("OTCalculate")} ?`}
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isOT"
            value={formData.isOT}
            onChange={handleChange}
          >
            <MenuItem value={1}>{t("Yes")}</MenuItem>
            <MenuItem value={0}>{t("No")}</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
      <Grid item xs={12}>
        <StyledContentLabel className="field-label">
          {`${t("ShiftFeeCalculate")} ?`}
        </StyledContentLabel>
        <StyledFormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="isShiftFee"
            value={formData.isShiftFee}
            onChange={handleChange}
          >
            <MenuItem value={1}>{t("Yes")}</MenuItem>
            <MenuItem value={0}>{t("No")}</MenuItem>
          </Select>
        </StyledFormControl>
      </Grid>
    </Grid>
  );
};

const DialogEdit = (props) => {
  const { open, mode, handleCloseDialog } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { result: userProfile } = useSelector((state) => state.userProfile);
  const { result: employeeProfile } = useSelector(
    (state) => state.employeeProfile
  );

  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (open) {
      setFormData({
        idEmp: employeeProfile.idEmp,
        isNonPayroll: employeeProfile.isNonPayroll,
        isPf: employeeProfile.isPf,
        isEWF: employeeProfile.isEWF || 0,
        isTax: employeeProfile.isTax,
        isSso: employeeProfile.isSso,
        isOT: employeeProfile.isOT,
        isShiftFee: employeeProfile.isShiftFee,
      });
    }
  }, [open]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    let data = { ...formData };
    data.UpdateBy = userProfile.idUsers;
    const result = await dispatch(updateUser(data));
    if (result) {
      handleCloseDialog();
      dispatch(getEmployeeProfile(employeeProfile.idEmp));
    }
  };

  return (
    <DrawerCustom
      title={`${t("PayrollCalculationSetting")}`}
      anchor={"right"}
      open={open}
      onClose={handleCloseDialog}
    >
      <StyledRoot>
        <Payroll formData={formData} handleChange={handleChange} />
        <StyledFooter>
          <ButtonBlue className="cancel" onClick={handleCloseDialog}>
            {t("Cancel")}
          </ButtonBlue>
          <ButtonBlue variant="contained" onClick={handleSubmit}>
            {t("Save")}
          </ButtonBlue>
        </StyledFooter>
      </StyledRoot>
    </DrawerCustom>
  );
};

export default DialogEdit;
